// extracted by mini-css-extract-plugin
export default {"list":"styles_list__v76ZU","type":"styles_type__6dK-d","info":"styles_info__5Iz5q","content":"styles_content__S44Cl"};